<template>
    <div class="header-dashboard">
        <section class="heading">
            <div class="heading-title">
                <div class="title">
                    <span class="dashboard">Dashboard</span>
                </div>

                <div class="hr" />

                
            </div>

            <div class="heading-today">
                <span>Última atualização: {{ lastUpdate | moment('dddd, [dia] DD [de] MMMM [de] YYYY [às] HH:mm:ss') }}.</span>
            </div>

            <div class="heading-hide-data">
                <ui-menu-card
                    icon="fal fa-cog"
                    icon-size="20"
                    @input="menuCardInput"
                >
                    <template #topControl>
                        <div class="title-subtitle">
                            <span class="title">Personalizar</span>
                            <span class="subtitle">Selecione até 5 cards</span>
                        </div>
                    </template>

                    <template #options>
                        <div class="actions-menu-card">
                            <ui-checkbox
                                v-for="(option, index) in menuCardOptions"
                                :id="index"
                                :key="index"
                                :label="option.label"
                                :checked="menuCardChecked.includes(option.type)"
                                design="xs success"
                                @input="menuCardHandler($event, index)"
                            />
                        </div>
                    </template>
                </ui-menu-card>
            </div>
        </section>

        <section class="heading-filters">
            <ui-actions-filter />
        </section>

        <section
            class="heading-card"
            :class="{'active-space-between': dataCardsComputed.length > 4}"
        >
            <div
                v-for="(card, index) in dataCardsComputed"
                :key="index"
                class="heading-card-user"
            >
                <ui-dashboard-users-card
                    :group-icon="card.group_icon"
                    :name-action-card="card.name_action_card"
                    :value-resource="card.value"
                    :variation="card.variation"
                    :loading="card.loading"
                    :infos="card.infos"
                    :negative-variation="card.negative_variation"
                    group-icon-tooltip="fal fa-info-circle"
                />
            </div>
        </section>

        <section class="comparative-data">
            <ui-comparative-data />
        </section>
    </div>
</template>

<script>
    import uiActionsFilter from '@/components/ui-facilita/dashboard-managers/actions-filter'
import uiComparativeData from '@/components/ui-facilita/dashboard-managers/comparative-data'
import uiDashboardUsersCard from '@/components/ui-facilita/dashboard-managers/dashboard-users-card'
import { uiCheckbox } from '@/components/ui/form'
import uiMenuCard from '@/components/ui/menu-card'

    import { mapState } from 'vuex'

    import { dashboard } from '@/services/axios'
import { storage } from '@/services/storage'

    import { currencyBRL } from '@/filters'
import { helpersMixin, utilMixin } from '@/mixins'

    const moment = require('moment')
	require('moment/locale/pt-br')

    const defaultCards = () => {
        return [
            'customers',
            'sales_rate',
            'sales',
            'vgv',
            'sales_cycle'
        ]
    }

    export default {
        name: 'header-dashboard',

        components: {
            uiMenuCard,
            uiCheckbox,
            uiDashboardUsersCard,
            uiActionsFilter,
            uiComparativeData
        },

        filters: { currencyBRL },

        mixins: [utilMixin, helpersMixin],

        data() {
            return {
                dataCards: [
                    {
                        type: 'customers',
                        position: 0,
                        group_icon: 'fal fa-user-friends',
                        name_action_card: 'Novos Clientes',
                        infos: 'Clientes cadastrados nos últimos 30 dias.',
                        value: 0,
                        variation: 0,
                        loading: false,
                        last_update: new Date()
                    },
                    {
                        type: 'sales',
                        position: 1,
                        group_icon: 'fal fa-hand-holding-usd',
                        name_action_card: 'Vendas Realizadas',
                        infos: 'Quantidade de clientes na etapa de venda ganha e com a data da venda dentro dos últimos 30 dias.',
                        value: 0,
                        variation: 0,
                        loading: false,
                        last_update: new Date()
                    },
                    {
                        type: 'sales_rate',
                        position: 2,
                        group_icon: 'fal fa-badge-percent',
                        name_action_card: 'Taxa de Venda Ganha',
                        infos: 'Porcentagem sobre a quantidade de clientes na etapa de venda ganha e com a data da venda dentro dos últimos 30 dias, dividido pela quantidade de novos clientes cadastrados nos últimos 30 dias.',
                        value: 0,
                        variation: 0,
                        loading: false,
                        last_update: new Date()
                    },
                    {
                        type: 'vgv',
                        position: 3,
                        group_icon: 'fal fa-wallet',
                        name_action_card: 'VGV',
                        infos: 'Soma do campo valor em dados da unidade, de todos os clientes na etapa de venda ganha e com a data da venda dentro dos últimos 30 dias.',
                        value: 0,
                        variation: 0,
                        loading: false,
                        last_update: new Date()
                    },
                    {
                        type: 'sales_cycle',
                        position: 4,
                        group_icon: 'fal fa-handshake',
                        name_action_card: 'Ciclo Médio de Vendas',
                        infos: 'Média em dias entre a data de cadastro do cliente até a sua entrada na etapa de venda ganha e com a data da venda nos últimos 30 dias.',
                        value: 0,
                        variation: 0,
                        loading: false,
                        last_update: new Date()
                    },
                    {
                        type: 'proposals',
                        position: 5,
                        group_icon: 'fal fa-file-alt',
                        name_action_card: 'Novas Propostas',
                        infos: 'Quantidade de clientes que passaram pela etapa de proposta nos últimos 30 dias.',
                        value: 0,
                        variation: 0,
                        loading: false,
                        last_update: new Date()
                    },
                    {
                        type: 'reserves',
                        position: 6,
                        group_icon: 'fal fa-grip-horizontal',
                        name_action_card: 'Novas Reservas',
                        infos: 'Quantidade de reservas criadas nos últimos 30 dias.',
                        value: 0,
                        variation: 0,
                        loading: false,
                        last_update: new Date()
                    }
                ],
                menuCardOptions: [
                    {
                        type: 'customers',
                        label: 'Novos Clientes'
                    },
                    {
                        type: 'sales_rate',
                        label: 'Taxa de Venda Ganha'
                    },
                    {
                        type: 'sales',
                        label: 'Vendas Realizadas'
                    },
                    {
                        type: 'vgv',
                        label: 'VGV'
                    },
                    {
                        type: 'sales_cycle',
                        label: 'Ciclo Médio de Vendas'
                    },
                    {
                        type: 'proposals',
                        label: 'Novas Propostas'
                    },
                    {
                        type: 'reserves',
                        label: 'Novas Reservas'
                    }
                ],
                menuCardChecked: [...defaultCards()]
            }
        },

        computed: {
            /**
             * Computed property que retorna apenas os cards selecionados no menu
             */
            dataCardsComputed() {
                // Caso o usuário tenha limpo as seleções de cards, mostra-se os cinco cards padrões
                const checked = this.$mx_hasValue(this.menuCardChecked)
                    ? [...this.menuCardChecked]
                    : defaultCards()

                return this.dataCards
                    .filter(card => checked.includes(card.type))
                    .sort((a, b) => a.position - b.position)
            },
            /**
             * Retorna a data de atualização mais recente dos cards
             */
            lastUpdate() {
                const cards = [...this.dataCards]

                return cards.sort((a, b) => {
                    return moment(a.last_update).format('YYYYMMDDHHmmss') - moment(b.last_update).format('YYYYMMDDHHmmss')
                }).find(() => true).last_update
            },

            ...mapState('dashboardFilter', ['appliedFilters']),

        },

        mounted() {
            this.loadData()
        },

        methods: {
            /**
             * Carrega os dados necessários para os cards de informações rápidas
             */
            loadData() {
                // Verifica se alguma seleção do menu de cards foi salva no localStorage
                this.menuCardChecked = storage.get('dashboard_menu_card_checked')
                    ? JSON.parse(storage.get('dashboard_menu_card_checked'))
                    : defaultCards()

                for (let card of this.dataCards) {
                    card.loading = true
                    const formatComparativeDate = (date) => {
                        return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD')

                        
                    }
                    
                    const filters = {
                        ...(this.appliedFilters.dateRange?.initialDate && { startDate: this.appliedFilters.dateRange.initialDate }),
                        ...(this.appliedFilters.dateRange?.finalDate && { endDate: this.appliedFilters.dateRange.finalDate }),
                        ...(this.appliedFilters.comparativeDate?.finalDate && {
                            dateComparation: `${formatComparativeDate(this.appliedFilters.comparativeDate.initialDate)} ${formatComparativeDate(this.appliedFilters.comparativeDate.finalDate)}`,
                        }),
                        ...(this.appliedFilters.teamFilter.team?.length > 0 && { teams: this.appliedFilters.teamFilter.team.map(selected => selected.id) }),
                        ...(this.appliedFilters.teamFilter.manager?.length > 0 && { managers: this.appliedFilters.teamFilter.manager.map(selected => selected.id) }),
                        ...(this.appliedFilters.teamFilter.broker?.length > 0 && { brokers: this.appliedFilters.teamFilter.broker.map(selected => selected.id) }),
                    };

                    dashboard.createV2('/cards', {
                        type: card.type,
                        "filters": filters
                     })
                        .then(response => {
                            const valueStr = String(response?.data?.data?.value || 0).replace(",", ".");
                            const variationStr = String(response?.data?.data?.variation || 0).replace(",", ".");

                            if (card.type == 'vgv') {
                                card.value = this.$options.filters.currencyBRL(valueStr)

                            } else if (['sales_rate', 'sales_cycle'].includes(card.type)) {
                                card.value = card.type === 'sales_rate'
                                    ? `${response?.data?.data?.value ? parseFloat(valueStr)
                                            .toFixed(2)
                                            .toString()
                                            .replace(/\./g, ",") : 0
                                        }%`
                                    : `${response?.data?.data?.value ? parseFloat(valueStr)
                                            .toFixed(2)
                                            .toString()
                                            .replace(/\./g, ",") : 0
                                        } dias`

                            } else {
                                card.value = this.$mx_numberFormat(valueStr)
                            }
                            card.variation = parseFloat(variationStr)
                                .toFixed(2)
                                .toString()
                                .replace(/\./g, ",")
                            // Define se a variação é negativa ou positiva, de acordo com o tipo do card
                            card.negative_variation = card.type === 'sales_cycle'
                                ? parseFloat(variationStr) > 0
                                : parseFloat(variationStr) < 0
                            card.last_update = response.data.data.last_update

                            // Adiciona as informações de Etapa e Status para o card de Novas Propostas
                            if (card.type === 'proposals') {
                                card.proposal = response.data.data.proposal
                                card.infos += card.proposal
                                    ? ` A configuração de proposal está ativa. A nova Etapa/Status de Proposta é ${response.data.data.funnel_stage_name}/${response.data.data.funnel_stage_status_name}.`
                                    : ''
                            }
                        })
                        .catch(error => {
                            if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        })
                        .finally(() => {
                            card.loading = false
                        })
                }
            },
            /**
             * Event handler que trata o evento de seleção dos cards de informações rápidas
             * a serem mostrados
             */
            menuCardHandler(event, index) {
                if (event) {
                    if (this.menuCardChecked.length === 5) this.menuCardChecked.pop()
                    this.menuCardChecked.push(this.menuCardOptions[index].type)

                } else {
                    const cIndex = this.menuCardChecked.findIndex(item => item === this.menuCardOptions[index].type)
                    this.menuCardChecked.splice(cIndex, 1)
                }

                storage.set('dashboard_menu_card_checked', JSON.stringify(this.menuCardChecked))
            },
            /**
             * Abre o modal para o usuário dar o feedback sobre a tela
             */
			openFeedbackModal() {
				this.$root.$emit('modal-open-feedback-modal')
			},
            /**
             * Identifica quando o menu que configura os cards mostrados foi utilizado
             */
            menuCardInput() {
                // Emite o evento do Google Analytics
                this.$gtm.trackEvent({
                    event: "fac_button_click",
                    category: 'vue-dashboard',
                    action: "click",
                    label: 'Personalizar Cards',
                })
            }
        },

        watch: {
            appliedFilters: {
                handler() {
                    this.loadData()
                },
                deep: true
            }
        },

    }
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>